import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';

export const ADD_HEADING_MUTATION = gql`
  mutation AddHeading($documentVersion: DocumentVersionInput!, $title: String!) {
    quotes {
      modify(documentVersion: $documentVersion) {
        addHeaderLine(description: $title) {
          newLines {
            id
            customProperties {
              key
              stringValue
            }
          }
        }
      }
    }
  }
`;

@Injectable({
  providedIn: 'root'
})
export class AddHeadingMutation extends Mutation<RootMutation> {
  document = ADD_HEADING_MUTATION;
}
